import React from 'react';
import moment from 'moment';
import axios from 'axios';
import isEqual from 'react-fast-compare';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next';
import Drawer from '@material-ui/core/Drawer';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import PersonAddIcon from '@material-ui/icons/PersonAdd';
import AddChildDialog from './AddChildDialog';
import DesktopDrawerPupil from './DesktopDrawerPupil';
import { getDefaultViewForPupil } from '../../helpers';
import { setData, fetchPupils } from '../../actions/index';

const styles = theme => ({
  toolbar: {
    ...theme.mixins.toolbar,
    backgroundColor: '#fff',
    cursor: 'pointer',
  },
  logoImage: {
    width: '60%',
    margin: '5px auto',
    display: 'block',
  },
  drawer: {
    width: 240,
  },
  paper: {
    backgroundColor: '#fafafa',
    width: 240,
    overflowX: 'hidden',
  },
  padding: {
    padding: 16,
  },
  addPupilButton: {
    color: '#000000',
    backgroundColor: '#e0e0e0',
    '&:hover': {
      backgroundColor: '#e9e9e9',
    },
    '& svg': {
      marginRight: 5,
    },
  },
  circularProgressWrapper: {
    textAlign: 'center',
    padding: 8,
  },
  dashboardListItem: {
    cursor: 'pointer',
    padding: '8px 24px 8px 16px',
    margin: '16px 32px 16px 0',
    color: '#394f5a',
    fontWeight: 'bold',
    borderTopRightRadius: 28,
    borderBottomRightRadius: 28,
    '&:hover': {
      backgroundColor: '#F1F1F1',
    },
  },
  dashboardListItemActive: {
    backgroundColor: '#FEE8E7 !important',
    color: '#f56a12 !important',
  },
});

const mapStateToProps = state => {
  return {
    selectedPupil: state.selectedPupil,
    pupils: state.pupils,
  };
};

function mapDispatchToProps(dispatch) {
  return {
    setData: (data, type) => dispatch(setData(data, type)),
    fetchPupils: (successCallback, errorCallback) => dispatch(fetchPupils(successCallback, errorCallback)),
  };
}

class DesktopDrawer extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      isLoaded: false,
      isDialogOpen: false,
    };

    this.lastPupilsRequestTime = null;

    this.onAddPupilClick = this.onAddPupilClick.bind(this);
    this.onDialogClose = this.onDialogClose.bind(this);
    this.onPupilViewClicked = this.onPupilViewClicked.bind(this);
    this.onDashboardClick = this.onDashboardClick.bind(this);
    this.onPupilAdded = this.onPupilAdded.bind(this);
    this.updatePupils = this.updatePupils.bind(this);
  }

  componentDidMount() {
    this.updatePupils();

    this.updatePupilsInterval = setInterval(() => {
      this.updatePupils();
    }, 180000);
  }

  componentWillUnmount() {
    clearInterval(this.updatePupilsInterval);
  }

  componentDidUpdate(prevProps, prevState) {
    if (!isEqual(this.props.pupils, prevProps.pupils)) {
      this.updatePupils();
    }
  }

  onAddPupilClick() {
    this.setState({
      isDialogOpen: true,
    });
  }

  onDialogClose() {
    this.setState({
      isDialogOpen: false,
    });
  }

  onPupilViewClicked(pupil, view) {
    if (view === '_first_available') {
      view = getDefaultViewForPupil(pupil);
    }

    pupil.defaultView = view;
    this.props.setData(pupil, 'selectedPupil');
  }

  onDashboardClick() {
    if (appType === 'parent') {
      window.location.hash = '';

      this.props.setData(null, 'selectedPupil');
    }
  }

  onPupilAdded() {
    this.setState({
      isDialogOpen: false,
    });

    this.updatePupils(true);
  }

  updatePupils(force = false) {
    if (appType === 'student') {
      return;
    }

    if (
      !force &&
      this.lastPupilsRequestTime &&
      moment().diff(this.lastPupilsRequestTime, 'milliseconds') < 5000
    ) {
      return;
    }

    this.lastPupilsRequestTime = moment();

    this.setState({
      isLoading: true,
    });

    this.props.fetchPupils(() => {
      this.setState({
        isLoading: false,
        isLoaded: true,
      });
    });
  }

  render() {
    const {
      classes,
      t,
      selectedPupil,
      pupils,
    } = this.props;
    const {
      isLoading,
      isLoaded,
      isDialogOpen,
    } = this.state;
    const logoUrl = 'https://195ec04504ea0272771e-7c2c6dacbab7a2b2d574b53c70c1fe31.ssl.cf3.rackcdn.com/6.1.31/img/logo/CC_logo.png';

    let activeItem = selectedPupil
      ? getDefaultViewForPupil(selectedPupil)
      : '';
    let selectedPupilId = -1;
    if (window.location.hash) {
      const hashSplit = window.location.hash.replace('#', '').split(',');
      selectedPupilId = parseInt(hashSplit[0]);
      activeItem = hashSplit[1];
    }

    const dashboardMenuItemClassName = selectedPupilId !== -1
      ? classes.dashboardListItem
      : `${classes.dashboardListItem} ${classes.dashboardListItemActive}`;

    return (
      <div className="desktop-drawer">
        <Drawer
          variant="permanent"
          className={classes.drawer}
          classes={{
            paper: classes.paper,
          }}
        >
          <div
            className={classes.toolbar}
            onClick={this.onDashboardClick}
          >
            <img
              className={classes.logoImage}
              src={logoUrl}
              alt="Logo"
            />
          </div>
          {appType === 'student' && selectedPupil && (
            <div>
              <DesktopDrawerPupil
                key={selectedPupil.id}
                pupil={selectedPupil}
                onPupilViewClicked={this.onPupilViewClicked}
                isOpen
                isAlwaysOpen
                activeItem={activeItem}
                useSuspense={false}
              />
            </div>
          )}
          {appType === 'parent' && (
            <div>
              <div
                className={dashboardMenuItemClassName}
                onClick={this.onDashboardClick}
              >
                {t('Dashboard')}
              </div>
              {!isLoaded && isLoading && (
                <div className={classes.circularProgressWrapper}>
                  <CircularProgress />
                </div>
              )}
              {isLoaded && (
                <div>
                  {pupils.map((pupil) => (
                    <DesktopDrawerPupil
                      key={pupil.id}
                      pupil={pupil}
                      onPupilViewClicked={this.onPupilViewClicked}
                      isOpen={selectedPupilId === pupil.id}
                      isAlwaysOpen={false}
                      activeItem={activeItem}
                      useSuspense={false}
                    />
                  ))}
                </div>
              )}
              <div className={classes.padding}>
                <Button
                  color="inherit"
                  onClick={this.onAddPupilClick}
                  className={`add-pupil-button-button ${classes.addPupilButton}`}
                >
                  <PersonAddIcon />
                  {t('Add Pupil')}
                </Button>
              </div>
            </div>
          )}
        </Drawer>
        <AddChildDialog
          isDialogOpen={isDialogOpen}
          onPupilAdded={this.onPupilAdded}
          onDialogClose={this.onDialogClose}
          useSuspense={false}
        />
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(
  withStyles(styles)(withTranslation()(DesktopDrawer))
);
